module.exports = __webpack_public_path__ + "static/media/IMG-1.aa07b08d.jpg";